import React, { FC } from 'react'
import PaginationButtons from '../../../../PaginationButtons'
import FhirLoader from '../../../../FhirLoader'
import { ProcedureBundle } from '../../../../../types/FHIRTypes/Bundle'
import { ProcedureTable } from '@teschglobal/tg-fhir-react-components'
import { isProcedureBundle } from '../../../../../typeGuards/fhirTypes'
import type { Procedure as FHIRProcedure } from '@teschglobal/tg-fhir-react-components/dist/types'

type ProcedureListProps = {
  procedureData?: ProcedureBundle
  isFetching: boolean
  handleChangePage: (page: number) => void
  totalPages: number
  currentPage: number
}

const ProcedureList: FC<ProcedureListProps> = ({
  procedureData,
  handleChangePage,
  isFetching,
  totalPages,
  currentPage,
}) => {
  if (!isProcedureBundle(procedureData)) return null

  const procedures: FHIRProcedure[] =
    procedureData?.entry ? procedureData.entry.map((p) => p.resource as FHIRProcedure) : []

  if (isFetching) {
    return <FhirLoader message="Loading..." />
  }

  return (
    <>
      {procedureData.total > 0 && (
        <div className="my-3 fw-bold">
          <span role="status" aria-live="polite">
            {procedureData.total.toLocaleString()} record(s) found
          </span>
          <PaginationButtons
            totalPages={totalPages}
            currentPage={currentPage}
            handleChangePage={handleChangePage}
          />
        </div>
      )}

      <ProcedureTable procedures={procedures} />

      {procedureData.total > 0 && (
        <div className="my-3 fw-bold">
          <PaginationButtons
            totalPages={totalPages}
            currentPage={currentPage}
            handleChangePage={handleChangePage}
          />
        </div>
      )}
    </>
  )
}

export default ProcedureList
